import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "DocumentInfo" }
const _hoisted_2 = { class: "DocumentInfo__id" }
const _hoisted_3 = { class: "DocumentInfo__prefix" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "DocumentInfo__date" }

import { computed, PropType } from "vue";
import { Document } from "@/types";
import InnInput from "@/components/ds/input/Input.vue";
import InnSelect from "@/components/ds/select/Select.vue";
import { documentToPrefix, documentToSlug } from "@/tools/document";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentInfo',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    editable: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const props = __props;

const slug = computed(() => documentToSlug(props.document));

const months = computed(() => {
    const monthsNl = [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december",
    ];
    const monthsEn = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const m = props.document.english ? monthsEn : monthsNl;
    return m.map((month, index) => ({ id: index + 1, title: month }));
});

const prefix = computed(() => documentToPrefix(props.document));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(prefix.value), 1),
      (__props.editable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(InnInput, {
              modelValue: __props.document.year,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.document.year) = $event)),
              compact: ""
            }, null, 8, ["modelValue"]),
            _cache[5] || (_cache[5] = _createTextVNode(" - ")),
            _createVNode(InnInput, {
              modelValue: __props.document.nr,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.document.nr) = $event)),
              compact: "",
              class: "DocumentInfo__nr"
            }, null, 8, ["modelValue"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(slug.value), 1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!__props.editable)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(__props.document.day) + " " + _toDisplayString(months.value[__props.document.month - 1].title) + " " + _toDisplayString(__props.document.year), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(InnInput, {
              modelValue: __props.document.day,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.document.day) = $event)),
              compact: "",
              class: "DocumentInfo__day"
            }, null, 8, ["modelValue"]),
            _createVNode(InnSelect, {
              items: months.value,
              modelValue: __props.document.month,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.document.month) = $event)),
              "item-title": "title",
              "item-value": "id",
              compact: ""
            }, null, 8, ["items", "modelValue"]),
            _createVNode(InnInput, {
              modelValue: __props.document.year,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.document.year) = $event)),
              compact: ""
            }, null, 8, ["modelValue"])
          ], 64))
    ])
  ]))
}
}

})